import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.css']
})
export class BankAccountComponent implements OnInit {

  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }


    
  BankAccountModel = {
    BankAccountID: 0,
    BankAccNumber: '',
    IsSalary: false,
    IsActive: true,
    BankAccountTypeD: 0,
    BankAccountType: '',
    BankName: '',
    BranchName: '',
    BranchAddress: '',
    BankID: 0,
    AccID:0
};
SearchBankAccountModel = {
    BankAccountID: 0,
    BankAccNumber: '',
    IsSalary: false,
    IsActive: true,
    BankAccountTypeD: 0,
    BankAccountType: '',
    BankName: '',
    BranchName: '',
    BranchAddress: '',
    BankID: 0
};
SelectedRowID = 0;
Submitted = false;
SearchClear  () {
    this.SelectedRowID = 0;
    this.SearchBankAccountModel.BankAccountID = 0;
    this.SearchBankAccountModel.BankAccNumber = '';
    this.SearchBankAccountModel.BankAccountTypeD = 0;
    this.SearchBankAccountModel.BankID = 0;
    this.SearchBankAccountModel.BranchName = '';
    this.SearchBankAccountModel.BranchAddress = '';
    this.SearchBankAccountModel.IsSalary = false;
    this.Submitted = false;
    this.SearchBankDetails();
};
Clear  () {
    this.SelectedRowID = 0;
    this.BankAccountModel.BankAccountID = 0;
    this.BankAccountModel.BankAccNumber = '';
    this.BankAccountModel.BankAccountTypeD = 0;
    this.BankAccountModel.BankID = 0;
    this.BankAccountModel.BranchName = '';
    this.BankAccountModel.BranchAddress = '';
    this.BankAccountModel.IsSalary = false;
    this.Submitted = false;
};
BankAccountType:any;
GetAccountType  () {
   this.lookupService.GetLookupsList('BankAccountType', '').subscribe( (data)=> {
        this.BankAccountType = data.LookupItems;
    });
};
BankList:any;
GetAllBank  () {
   this.lookupService.GetLookupsList('BankAll', '').subscribe( (data)=> {
        this.BankList = data.LookupItems;
    });
};
Validation  () {
  
   return this.BankAccountModel.BankID == 0 || this.BankAccountModel.BankAccNumber == '' || this.BankAccountModel.BankAccountTypeD == 0 || this.BankAccountModel.BranchName == '';

}
loading = false;
SaveBankDetails  () {
    this.Submitted = true;
    if (!this.Validation()) {
        this.loading = true;
        this.spinnerService.show();
       this.accService.SaveBankDetails(JSON.stringify(this.BankAccountModel)).subscribe( (response)=> {
            setTimeout( () =>{
                
                this.loading = false;
            }, 10);
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(response);

            if (response.webResponse.Status) {
                if (this.BankAccountModel.BankAccountID==0) {
                    this.Clear();
                }
                
                this.SearchBankDetails();
            }

        });
    }
};
ListBankDetails:any;
SearchBankDetails  () {
    this.spinnerService.show();
   this.accService.SearchBankDetails(JSON.stringify(this.SearchBankAccountModel)).subscribe( (response)=> {
        this.ListBankDetails = response.ListBankDetails;
        this.spinnerService.hide();
    });
};

UpdateBankAccount  (item) {
    var BankAccountID = item.BankAccountID;
    var IsActive = item.IsActive == true ? false : true;
   this.accService.UpdateBankAccount(BankAccountID, IsActive).subscribe( (response)=> {
        
        this.SearchBankDetails();
    });
};

Edit  (obj) {
    this.SelectedRowID = obj.BankAccountID;
    this.BankAccountModel.BankAccountID = obj.BankAccountID;
    this.BankAccountModel.BankAccNumber = obj.BankAccNumber;
    this.BankAccountModel.IsActive = obj.IsActive;
    this.BankAccountModel.IsSalary = obj.IsSalary;
    this.BankAccountModel.BankAccountTypeD = obj.BankAccountTypeD;
    this.BankAccountModel.BankID = obj.BankID;
    this.BankAccountModel.BranchName = obj.BranchName;
    this.BankAccountModel.BranchAddress = obj.BranchAddress;
    this.BankAccountModel.AccID = obj.AccID;
    
};












  ngOnInit() {
    this.GetAllBank();
    this.GetAccountType();
    this.SearchBankDetails();
  }

}
